import React from "react";

import type { TwoUpCaptionCardBlock as Value } from "@reactivated";

import { MediaChooserBlock } from "../MediaChooserBlock";
import { RichText } from "../RichText";
import type { Layout } from "./";

import styles from "./TwoUpCaptionCard.module.scss";

const imageWrapperClass = (layout: Layout, index: number): string => {
    if (layout === "symmetric") return styles.symmetric;
    return index === 0 ? styles.asymmetricLarge : styles.asymmetricSmall;
};

const imageSizes = (layout: Layout, index: number): string => {
    if (layout === "symmetric") return styles.sizesSymmetric;
    return index === 0
        ? styles.sizesAsymmetricLarge
        : styles.sizesAsymmetricSmall;
};

export const TwoUpCaptionCard = ({
    value,
    layout,
    index,
}: {
    value: Value;
    layout: Layout;
    index: number;
}) => {
    if (!value.media) return <></>;

    return (
        <div>
            <div className={imageWrapperClass(layout, index)}>
                <MediaChooserBlock
                    value={value.media}
                    wrapperAttrs={{ className: styles.media }}
                    imageProps={{
                        sizes: imageSizes(layout, index),
                    }}
                />
            </div>
            {value.caption && (
                <RichText value={value.caption} className={styles.caption} />
            )}
        </div>
    );
};
